import { QuestionBase } from './base.question.class'

export class ScoreResultQuestion extends QuestionBase<string> {
  controlType = 'score-result'

  getValidators() {
    return []
  }
}
